import { cva } from '@/styled-system/css';

export const progressStepperRootRecipe = cva({
  base: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    minHeight: 'ProgressMeter.Node.focusRing.default.hover',
  },
  variants: {
    orientation: {
      horizontal: {
        paddingBlockStart:
          'calc(({sizes.ProgressMeter.Node.focusRing.default.hover} - {sizes.ProgressMeter.Node.default}) / 2)',
      },
      vertical: {
        paddingInlineStart:
          'calc(({sizes.ProgressMeter.Node.focusRing.default.hover} - {sizes.ProgressMeter.Node.default}) / 2)',
      },
    },
  },
});
